import { useField } from 'formik';
import React from 'react';
import { TextField } from '@a-ui/react';

import { IClassNames } from '../../hooks/classNames.hooks';
import { translate } from '../../i18n';

interface TelephoneFieldProps extends IClassNames {
  name?: string;
  required?: boolean;
  id?: string;
  label?: string;
}

const TelephoneField: React.FC<TelephoneFieldProps> = ({
  name,
  required = true,
  id,
  label,
  ...props
}) => {
  const [, , { setValue }] = useField(name || '');
  const fieldWrapper = React.useRef<HTMLDivElement>(null);

  const trimValue = (value: string) => value?.replace(/^0+/, '').replace(/\s+/g, '');

  const handleValueChange = (e: any) => {
    const number = trimValue(e.target.value);
    setValue(number ? `${number}` : undefined);
  };

  return (
    <div className={`a-input${required ? ' is-required' : ''}`}>
      {label && (
        <label className="a-input__label" htmlFor={id}>
          {label}
        </label>
      )}
      <div className="ckp-m-telephone-field" ref={fieldWrapper}>
        <TextField
          id={id}
          name={name}
          description={translate('accessKeys.phone.description')}
          onChange={handleValueChange}
          required={required}
          {...props}
        />
      </div>
    </div>
  );
};

export default TelephoneField;
